import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/aa72c47e-d4e8-4d44-8e0f-a94d726b8acd.jpg';
export function Hero() {
  return <section id="top" className="relative flex min-h-screen w-full overflow-hidden bg-[#071C3D]" data-id="element-102" data-mp="9l34fchccc3z">
      <div className="absolute inset-0" aria-hidden="true" data-id="element-103" data-mp="4njqkdok21ck">
        <img src={HERO_IMG} alt="" className="h-full w-full object-cover object-center" data-id="element-104" data-mp="129qudld1bpnv" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(135deg, rgba(10, 14, 26, 0.82) 0%, rgba(15, 41, 148, 0.5) 50%, rgba(10, 14, 26, 0.86) 100%)'
      }} data-id="element-105" data-mp="x9urjpg2q49w" />
        <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-vm-bg/90 to-transparent" data-id="element-106" data-mp="nbosdflnjc8q" />
      </div>

      <div className="relative z-10 flex w-full flex-col justify-between gap-12 px-6 pb-8 pt-36 lg:px-10 lg:pb-10 lg:pt-32" data-id="element-107" data-mp="3czfoc8080na9">
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mx-auto flex w-full max-w-7xl flex-1 flex-col items-center justify-between gap-12 text-center sm:gap-16" data-id="element-108" data-mp="3j8selyn99fos">
          <p className="text-xs font-medium uppercase tracking-[0.25em] text-vm-muted" data-id="element-109" data-mp="3e8mur4n88xh9">
            Tecnología visual en movimiento
          </p>

          <h1 className="mx-auto max-w-full font-bornia text-[clamp(37px,10.5vw,48px)] font-extrabold uppercase leading-[1.3] tracking-[-0.02em] text-white lg:text-[clamp(68px,6vw,96px)] lg:leading-[1.24]" data-id="element-110" data-mp="30fy8lu7m0xwp">
            <span className="block" data-id="element-111" data-mp="2qi0l58xkr555">Creamos historias</span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.01em] lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-112" data-mp="2vjpywwc6lwwx">que conectan</span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.01em] text-vm-cream lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-113" data-mp="2hl9q8zurdwc5">marcas <span className="text-white" data-id="element-114" data-mp="s1rsao8pe6ua">con</span></span>
            <span className="block text-[clamp(34px,9.5vw,44px)] tracking-[-0.01em] text-vm-cream lg:text-[clamp(62px,5.5vw,88px)]" data-id="element-115" data-mp="s3cmudv0pps5">personas</span>
          </h1>

          <a href="#contacto" className="inline-flex items-center gap-3 rounded-2xl bg-vm-sky px-7 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-vm-bg shadow-lg shadow-black/20 transition-all duration-200 hover:-translate-y-0.5 hover:bg-vm-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-vm-sky focus-visible:ring-offset-4 focus-visible:ring-offset-vm-bg" data-id="element-116" data-mp="ibgiwm6935g0">
            <FileTextIcon className="h-5 w-5" aria-hidden="true" data-id="element-117" data-mp="11150ldl3cpdf" />
            Conversemos tu proyecto
          </a>
        </motion.div>

        <div className="mx-auto mt-10 flex w-full max-w-7xl items-center justify-between border-t border-white/20 pt-5 text-[10px] font-medium uppercase tracking-[0.25em] text-vm-muted sm:text-xs" data-id="element-118" data-mp="3lsyt309hwojl">
          <span data-id="element-119" data-mp="1x9b3owgzwtag">Vivo Media</span>
          <span data-id="element-120" data-mp="1xa43fdhjeij3">Desde Uruguay</span>
        </div>
      </div>
    </section>;
}